import cx from 'classnames'
import { type KeenSliderInstance } from 'keen-slider'

interface GalleryCarouselDotProps {
  index: number
  label: string
  slider: KeenSliderInstance | null
  currentSlide: number
}

const GalleryCarouselDot = ({
  index,
  label,
  slider,
  currentSlide,
}: GalleryCarouselDotProps) => {
  return (
    <button
      onClick={() => slider?.moveToIdx(index)}
      aria-label={label.replace(/{index}/gi, (index + 1).toString())}
      className={cx(
        'p-1 bg-transparent',
        'before:block before:relative before:w-2 before:h-2 before:bg-pageBG before:rounded-full before:opacity-30',
        'before:transition-carousel-dots',
        'hover:before:opacity-100',
        {
          'before:opacity-100 transform scale-150': currentSlide === index,
        },
      )}
    />
  )
}

export default GalleryCarouselDot
